import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import methods from 'config/orderMethods.json';

const MethodDetails = ({ method, label, selected }) => {
    const selectedMethod = methods[method].find((item) => item.id === Number(selected.id)) || null;

    return (
        <li className="item" id={`${method}-${selected.id}`}>
            <span className="item__label">{label}</span>
            <div className="item__value align-items-center d-inline-flex">
                {selectedMethod ? (<Fragment>
                    <div className="item__image">
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/${method}/${selectedMethod.shortName}.png`}
                            className="item__method-image"
                            alt={selected.method}
                            title={selected.method}
                        />

                    </div>
                    <strong>{selected.method}</strong>
                </Fragment>) : (
                        <strong>{selected.method}</strong>
                    )}
            </div>
        </li>
    );
};

MethodDetails.propTypes = {
    method: PropTypes.string,
    label: PropTypes.string,
    selected: PropTypes.object,
};

export default MethodDetails;
